import Api from "../../api.js";

export const getItem = async (url) => {
    return (await Api(url))?.data?.item
}
